__turbopack_context__.v({
  "jobNetNetStep": "FZ0M4q_jobNetNetStep",
  "jobNetNetStep__badgeStack": "FZ0M4q_jobNetNetStep__badgeStack",
  "jobNetNetStep__breakdown": "FZ0M4q_jobNetNetStep__breakdown",
  "jobNetNetStep__breakdownLabel": "FZ0M4q_jobNetNetStep__breakdownLabel",
  "jobNetNetStep__breakdownList": "FZ0M4q_jobNetNetStep__breakdownList",
  "jobNetNetStep__breakdownPct": "FZ0M4q_jobNetNetStep__breakdownPct",
  "jobNetNetStep__breakdownRow": "FZ0M4q_jobNetNetStep__breakdownRow",
  "jobNetNetStep__breakdownRowTop": "FZ0M4q_jobNetNetStep__breakdownRowTop",
  "jobNetNetStep__breakdownSubtitle": "FZ0M4q_jobNetNetStep__breakdownSubtitle",
  "jobNetNetStep__breakdownTitle": "FZ0M4q_jobNetNetStep__breakdownTitle",
  "jobNetNetStep__budgetGrid": "FZ0M4q_jobNetNetStep__budgetGrid",
  "jobNetNetStep__budgetLeftStack": "FZ0M4q_jobNetNetStep__budgetLeftStack",
  "jobNetNetStep__budgetPanel": "FZ0M4q_jobNetNetStep__budgetPanel",
  "jobNetNetStep__budgetSubtitle": "FZ0M4q_jobNetNetStep__budgetSubtitle",
  "jobNetNetStep__budgetTitle": "FZ0M4q_jobNetNetStep__budgetTitle",
  "jobNetNetStep__deliverablesTable": "FZ0M4q_jobNetNetStep__deliverablesTable",
  "jobNetNetStep__deliverablesTableWrap": "FZ0M4q_jobNetNetStep__deliverablesTableWrap",
  "jobNetNetStep__footer": "FZ0M4q_jobNetNetStep__footer",
  "jobNetNetStep__header": "FZ0M4q_jobNetNetStep__header",
  "jobNetNetStep__lineItem": "FZ0M4q_jobNetNetStep__lineItem",
  "jobNetNetStep__lineValue": "FZ0M4q_jobNetNetStep__lineValue",
  "jobNetNetStep__numericCell": "FZ0M4q_jobNetNetStep__numericCell",
  "jobNetNetStep__panel": "FZ0M4q_jobNetNetStep__panel",
  "jobNetNetStep__revenueByType": "FZ0M4q_jobNetNetStep__revenueByType",
  "jobNetNetStep__subpanelTitle": "FZ0M4q_jobNetNetStep__subpanelTitle",
  "jobNetNetStep__subtitle": "FZ0M4q_jobNetNetStep__subtitle",
  "jobNetNetStep__summaryLine": "FZ0M4q_jobNetNetStep__summaryLine",
  "jobNetNetStep__title": "FZ0M4q_jobNetNetStep__title",
  "jobNetNetStep__topGrid": "FZ0M4q_jobNetNetStep__topGrid",
});
